const getPixelFromLatLng = function (map, latLng) {
  let projection = map.getProjection();
  let point = projection.fromLatLngToPoint(latLng);

  return point;
};

const calculateInfoWindowOffset = function (map, marker) {
  if (!map && !marker) {
    return {};
  }

  let center = getPixelFromLatLng(map, map.getCenter());
  let point = getPixelFromLatLng(map, marker.getPosition());
  let quadrant = '';
  let offset;

  quadrant += point.y > center.y ? 'b' : 't';
  quadrant += point.x < center.x ? 'l' : 'r';
  if (quadrant === 'tr') {
    offset = new google.maps.Size(-170, 185);
  } else if (quadrant === 'tl') {
    offset = new google.maps.Size(170, 185);
  } else if (quadrant === 'br') {
    offset = new google.maps.Size(-170, 50);
  } else if (quadrant === 'bl') {
    offset = new google.maps.Size(170, 50);
  }

  return offset;
};

export default calculateInfoWindowOffset;
